import React from 'react';
import { Unauthorized } from '../../components/unauthorized';

/**
 * View responsible for providing the FAQ view component with its corresponding hero teaser
 */
export const UnauthorizedPage: React.FC = () => {
    return <Unauthorized />;
};
